import {connect} from '@modifi/redux'
import {path} from 'ramda'
import {selectSearchObj, aReplace} from '@modifi/router'

import Filter from './Filter'

export type {CommonFilterProps, FilterOption} from './Filter'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>) => ({
  location: path(['router', 'location'], state),
  search: selectSearchObj(state),
})

const mapDispatchToProps = {
  replaceUrl: aReplace,
}

// @ts-expect-error to be fixed
export default connect(mapStateToProps, mapDispatchToProps)(Filter)
